module.exports = __webpack_public_path__ + "img/bank_img5.889c7397.png";